import React from 'react';
import { Paper, Grid, Avatar, Box, Typography } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme';

export default function SummaryCard({ counts = {} }) {
  const theme = useTheme();
  tokens(theme.palette.mode);

  const items = [
    { icon: <FormatListBulletedIcon />, label: 'Total Item', value: counts.total || 0, colorBg: '#e8f3ff', color: '#1e88ff' },
    { icon: <WarningAmberIcon />, label: 'Must Use', value: counts.mustUse || 0, colorBg: '#fff6dd', color: '#fb8c00' },
    { icon: <CheckCircleIcon />, label: 'Ready', value: counts.ready || 0, colorBg: '#e3f8ff', color: '#00a9c6' },
    { icon: <CancelIcon />, label: 'Expired', value: counts.expired || 0, colorBg: '#ffe9ee', color: '#ef3d3d' },
    { icon: <ChecklistRtlIcon />, label: 'Preparing', value: counts.preparing || 0, colorBg: '#e8f7ea', color: '#3ca954' },
  ];

  return (
    <Paper sx={{ p: { xs: 1.2, md: 1.7 }, borderRadius: 2, boxShadow: 'none', minHeight: { md: 227 } }}>
      <Typography sx={{ fontSize: 20, mb: 1.2, fontWeight: 700 }}>สรุปข้อมูล</Typography>
      <Grid container spacing={1.1}>
        {items.map((it, idx) => (
          <Grid item xs={6} key={idx} sx={idx === 4 ? { mt: 0.2 } : undefined}>
            <Paper sx={{ p: 0.5, borderRadius: 1.2, display: 'flex', alignItems: 'center' }} elevation={0}>
              <Avatar sx={{ bgcolor: it.colorBg, color: it.color, mr: 1.1, width: 46, height: 46 }}>
                {it.icon}
              </Avatar>
              <Box>
                <Typography sx={{ fontWeight: 500, fontSize: 16, lineHeight: 1 }}>{it.value}</Typography>
                <Typography sx={{ fontSize: 16, color: it.color }}>{it.label}</Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
